import type { AxiosInstance } from 'axios';
import { BaseService } from './BaseService';
import type {
  SpecConstraintViewModel,
  SpecConstraintCreateModel,
  SpecConstraintUpdateModel,
} from '../types/spec-constraint/SpecConstraintModels';
import { apiClient } from '../client/client';

export class SpecConstraintService extends BaseService<
  SpecConstraintViewModel,
  SpecConstraintCreateModel,
  SpecConstraintUpdateModel,
  SpecConstraintViewModel[]
> {
  private static readonly BASE = '/api/spec-constraint';

  constructor(client: AxiosInstance = apiClient) {
    super(client, SpecConstraintService.BASE);
  }
}

export const specConstraintService = new SpecConstraintService();
